import { useTranslation } from "react-i18next";

export default function TypeOfPermit({ permit }) {
  const { t } = useTranslation();

  return (
    <div className="col-6 remote-work-options">
      <h1>{t("Type of Permit")}</h1>
      <div className="selected-areas">
        {permit && permit.length > 0 ? (
          <div>{t(permit)}</div>
        ) : (
          <div>
            {t("There are no type of permit selected for this interview")}
          </div>
        )}
      </div>
    </div>
  );
}
